<template>
  <div class="info-box static">
    <div class="flex-1 overflow-y-auto gap-x-3">
      <el-form
        :model="state.model"
        label-width="auto"
        label-position="top"
        ref="formDom"
        size="large"
        class="px-2.5"
      >
        <ul class="grid gap-x-5" style="grid-template-columns: 200px 1fr">
          <el-form-item
            label="日期"
            prop="date"
            :rules="[
              { required: true, message: '请选择日期', trigger: 'blur' },
            ]"
          >
            <el-date-picker
              v-model="state.model.date"
              type="date"
              placeholder="日期"
              value-format="YYYY-MM-DD"
              class="!w-full"
            />
          </el-form-item>
          <el-form-item
            label="类型"
            prop="d_meeting_log_type_id"
            :rules="[
              { required: true, message: '请选择类型', trigger: 'blur' },
            ]"
          >
            <el-select v-model="state.model.d_meeting_log_type_id">
              <el-option
                v-for="item in state.type_data"
                :key="item"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </ul>
        <el-form-item label="内容">
          <c_editor
            @change="
              (value) => {
                state.model.content = value;
              }
            "
            class="flex flex-col h-full"
            :value="state.model.content"
          ></c_editor>
        </el-form-item>
        <el-form-item label="附件">
          <template #label>
            <div class="flex items-center">
              <text>附件</text>
              <el-upload
                :show-file-list="false"
                :auto-upload="false"
                multiple
                :on-change="onFileChange"
              >
                <el-button type="primary" size="small" link icon="plus">
                  上传
                </el-button>
              </el-upload>
            </div>
          </template>
          <div class="w-full flex flex-wrap gap-x-5 gap-y-2">
            <li
              v-for="(file, index) in state.model.files"
              class="grid items-center hover:underline cursor-pointer text-green-700"
              style="grid-template-columns: 1fr auto"
              @click="$openFile(file.file_url)"
            >
              <text>{{ file.origin_filename }}</text>
              <el-icon
                color="#f00"
                @click.stop="state.model.files?.splice(index, 1)"
                class="hover:scale-110 text-red-400 cursor-pointer ml-2"
              >
                <Close />
              </el-icon>
            </li>
          </div>
        </el-form-item>

        <!-- <el-form-item label="图片">
          <div class="flex flex-wrap gap-3">
            <el-upload
              :show-file-list="false"
              :auto-upload="false"
              multiple
              :on-change="onFileChange"
            >
              <el-button
                dashed
                plan
                icon="plus"
                style="color: var(--el-color-primary)"
                size="large"
                class="!text-xs hover:!text-green-600 hover:!border-green-600 !w-32 !h-20 p-5"
              >
                上传
              </el-button>
            </el-upload>
            <el-image
              v-for="(item, index) in state.model.files"
              :key="item"
              class="w-32 h-20"
              :src="item.file_url"
              :initial-index="index"
              :preview-src-list="state.model.files?.map((m) => m.file_url)"
              preview-teleported
            />
          </div>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="submit-box px-2.5">
      <el-button type="primary" @click="onSubmit"> 提交 </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  meeting_log_detail,
  meeting_log_add,
  meeting_log_edit,
} from "@/http/meeting";
import { dic_getMeetingLogType } from "@/http/data";
import { post_response } from "@/utils/funcs";
import { attachment_upload } from "@/http/attachment";

export default {
  props: {
    id: Number,
    meeting_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: { meeting_id: props.meeting_id, status: 1, files: [] },
    });
    onMounted(() => {
      onLoadType();

      if (props.id) {
        meeting_log_detail(props.id).then((res) => {
          if (res.status == 200) {
            const data = res.data?.data;
            state.model = data;
            state.model.files = data.attachment.map((m) => {
              return {
                id: m.id,
                origin_filename: m.filename,
                file_url: m.file_url,
              };
            });
          }
        });
      }
    });

    //获取日志类型
    const onLoadType = () => {
      dic_getMeetingLogType().then((res) => {
        if (res.status == 200) {
          state.type_data = res.data?.data || [];
        }
      });
    };

    const onFileChange = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          state.model.files = [...state.model.files, ...res.data.data];
        }
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          state.model.attachment = JSON.stringify(
            state.model.files?.map((m) => m.id),
          );
          if (props.id) {
            meeting_log_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            meeting_log_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onFileChange,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
